import { useQuery } from '@tanstack/react-query';
import { fetchRevenueAccounts, fetchRevenueInvoices, fetchRevenueSummary } from '../api';
import type { RevenueQueryParams } from '../types';

export const revenueKeys = {
  all: ['revenue'] as const,
  accounts: (params?: RevenueQueryParams) => [...revenueKeys.all, 'accounts', params] as const,
  invoices: (params?: RevenueQueryParams) => [...revenueKeys.all, 'invoices', params] as const,
  summary: (params?: { year?: number; month?: string }) => [...revenueKeys.all, 'summary', params] as const,
};

export function useRevenueAccounts(params?: RevenueQueryParams) {
  return useQuery({
    queryKey: revenueKeys.accounts(params),
    queryFn: () => fetchRevenueAccounts(params),
    staleTime: 1000 * 60 * 5,
  });
}

export function useRevenueInvoices(params?: RevenueQueryParams) {
  return useQuery({
    queryKey: revenueKeys.invoices(params),
    queryFn: () => fetchRevenueInvoices(params),
    staleTime: 1000 * 60 * 5,
  });
}

export function useRevenueSummary(params?: { year?: number; month?: string }) {
  return useQuery({
    queryKey: revenueKeys.summary(params),
    queryFn: () => fetchRevenueSummary(params),
    staleTime: 1000 * 60 * 5,
  });
}

export function useAccountInvoices(invAccountId: string | null) {
  const params: RevenueQueryParams | undefined = invAccountId
    ? { inv_account_id: invAccountId, page_length: 100 }
    : undefined;

  return useQuery({
    queryKey: revenueKeys.invoices(params),
    queryFn: () => fetchRevenueInvoices(params!),
    enabled: !!invAccountId,
    staleTime: 1000 * 60 * 5,
  });
}
